import { Capability } from '@/actions/dtos/subscription';
import { useAccount } from '@/hooks/useAccount';
import { useAuthenticated } from '@/hooks/useAuthenticated';

const QUESTIONS_CARD_LIMIT_THRESHOLD = 10;
const SEARCH_QUERY_CARD_LIMIT_THRESHOLD = 20;

export const useSubscriptionLimits = () => {
  const { isAuthenticated } = useAuthenticated();
  const { usage, limits } = useAccount();

  const isLimitReached = (type: Capability): boolean =>
    !!(isAuthenticated && usage && limits && usage[type] >= limits[type]);

  const shouldShowLimitCard = (type: Capability, threshold: number): boolean =>
    !!(isAuthenticated && usage && limits && limits[type] - usage[type] <= threshold);

  return {
    isSearchLimitReached: isLimitReached(Capability.QUERIES),
    isAgentLimitReached: isLimitReached(Capability.AGENTS),
    isAccountLimitReached: isLimitReached(Capability.ACCOUNTS),
    isShortlistLimitReached: isLimitReached(Capability.SHORTLISTS),
    isQuestionLimitReached: isLimitReached(Capability.QUESTIONS),
    isWebhookLimitReached: isLimitReached(Capability.WEBHOOKS),
    showQuestionLimitCard: shouldShowLimitCard(Capability.QUESTIONS, QUESTIONS_CARD_LIMIT_THRESHOLD),
    showSearchQueryLimitCard: shouldShowLimitCard(Capability.QUERIES, SEARCH_QUERY_CARD_LIMIT_THRESHOLD),
  };
};
